import { useContext } from 'react';

import { AIPermissionModalContext } from './AIPermissionModalContext';

export default function useAIPermissionModalContext() {
  const context = useContext(AIPermissionModalContext);

  if (context === undefined) {
    throw new Error('useAIPermissionModalContext must be used within an AIPermissionModalProvider');
  }

  return context;
}
